import React from "react";
import DrawerAppBar from "./NavbarComponent";

const Navbar = () => {
  return (
    <>
      <DrawerAppBar />
    </>
  );
};

export default Navbar;
